import './ProcessingIcon.scss';
import classNames from 'classnames';
import { LoadingSpinner } from '@ui/LoadingSpinner';
import React from 'react';
import { SalesforceCloudError } from '@ui/icons/SalesforceCloudError';
import { Tooltip } from 'antd';
import { CheckCircleOutlined, CloseCircleOutlined } from '@ant-design/icons';
import { SalesforceCloudCheck, SalesforceCloudOutline } from '@ui/lottie';
export const ProcessingIcon = ({ className, isSalesforce, errorsOnly = !isSalesforce, isProcessing, placement = 'bottom', result }) => {
    let icon = null;
    const success = (result === null || result === void 0 ? void 0 : result.success) && !errorsOnly;
    const error = result && !result.success;
    const processing = isProcessing && !errorsOnly;
    if (!isProcessing && !result) {
        return icon;
    }
    if (success) {
        icon = isSalesforce ? React.createElement(SalesforceCloudCheck, null) : React.createElement(CheckCircleOutlined, null);
    }
    if (error) {
        icon =
            React.createElement(Tooltip, { placement: placement, title: result.message }, isSalesforce ? React.createElement(SalesforceCloudError, null) : React.createElement(CloseCircleOutlined, null));
    }
    if (processing) {
        icon = isSalesforce ?
            React.createElement(SalesforceCloudOutline, null) :
            React.createElement(LoadingSpinner, { size: 'small', spinning: true });
    }
    return (React.createElement("div", { className: classNames('processing-icon', {
            error,
            success
        }, className) }, icon));
};
